// Path: src\Components\Rewards\RewardStore\ReedemCouponPopup.jsx
import React, { useCallback, useEffect, useRef, useState } from "react";
import myntra from "../../../assets/images/myntra.png";
import TextFieldWithButton from "../../CommonFields/Textfieldwithbutton";
import Coin from "../../../images/coin.png";
import CurrencyIcon from "../../../images/Diamond.png";
import { myRewardProductDetails } from "../../../api/rewardProduct.api";
import { url } from '../../../config/url';
import { toastError } from "../../../Utilities/toast";
import { toastInfo } from '../../../Utilities/toast'
import moment from "moment";
import ListLoader from '../../Common/ListLoader';
const ReedemPopup = ({ isOpen, onClose, myReedemItem, children }) => {
  const [rewardDetails, setRewardDetails] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    fetchRewardDetails();
  }, [])

  const fetchRewardDetails = async () => {
    setIsLoading(true)
    try {
      const res = await myRewardProductDetails(myReedemItem?._id);
      setIsLoading(false)
      if (res?.success && res?.data) {
        setRewardDetails(res?.data);
      }
      else {
        toastError(res?.data?.errors?.[0]?.msg);
      }
    } catch (error) {
      setIsLoading(false)
      toastError(error?.response?.data?.errors?.[0]?.msg);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toastInfo("code copied");
    }).catch(err => {
      console.error("Failed to copy: ", err);
    });
  };

  return (
    <div className="popupinner-wrapper">
      <div className="popup-overlay">
        <div className="popup-container" style={{ padding: "2.8rem" }}>
          <button className="close-btn" onClick={onClose}>
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.8" filter="url(#filter0_b_2731_8186)">
                <circle
                  cx="16"
                  cy="16"
                  r="16"
                  fill="#82838E"
                  fill-opacity="0.5"
                />
              </g>
              <rect
                x="12.0531"
                y="10.9065"
                width="13.3333"
                height="1.96078"
                rx="0.980392"
                transform="rotate(45 12.0531 10.9065)"
                fill="#F4F4F4"
              />
              <rect
                x="10.6666"
                y="20.3345"
                width="13.3333"
                height="1.96078"
                rx="0.980392"
                transform="rotate(-45 10.6666 20.3345)"
                fill="#F4F4F4"
              />
              <defs>
                <filter
                  id="filter0_b_2731_8186"
                  x="-24"
                  y="-24"
                  width="80"
                  height="80"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_2731_8186"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_2731_8186"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </button>
          <div className="popup-title-img-wrap mb-4">
            <div>
              <img className="reward-store-popup-img" src={url?.IMAGE_URL + myReedemItem?.img?.default}></img>
            </div>
          </div>
          <div className="space-between">
            <div className="popup-body">
              <div className="reedemcoupon-box">
                {/* Left SVG */}
                <div className="reedemcoupon-box-left-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="38"
                    height="38"
                    viewBox="0 0 38 38"
                    fill="none"
                  >
                    <circle cx="19" cy="19" r="19" fill="#2D2E40" />
                  </svg>
                </div>

                {/* Main Content */}
                <div className="reedemcoupon-box-content">
                  <div className="reedemcoupon-box-header">
                    <div className="reedemcoupon-box-title">
                    {myReedemItem?.name?.length > 17 ? (
                        <marquee>  {myReedemItem?.name}</marquee>
                      ) : (
                        myReedemItem?.name
                      )}
                      {/* {myReedemItem?.name} */}
                      </div>

                    <div className="reedemcoupon-box-points">
                    
                      {" " + myReedemItem?.redeemInfo?.amount}
                      <span className="ms-1">
                        {myReedemItem?.redeemInfo?.currency?.code === "INR" ?
                          myReedemItem?.redeemInfo?.currency?.symbol
                          :
                          <img className='rewardstore-img-icon-size mb-1' src={url?.IMAGE_URL + myReedemItem?.redeemInfo?.currency?.img?.default} alt={myReedemItem?.name} />
                        }
                      </span>
                    </div>



                  </div>
                  <div className="reedemecoupon-box-flex">
                    <div className="reedemcoupon-box-price mb-3">
                    {" " + myReedemItem?.voucherInfo?.amount}
                      <span className="ms-1">
                        {myReedemItem?.voucherInfo?.currency?.code === "INR" ?
                          myReedemItem?.voucherInfo?.currency?.symbol
                          :
                          <img className='rewardstore-img-icon-size' src={url?.IMAGE_URL + myReedemItem?.voucherInfo?.currency?.img?.default} alt={myReedemItem?.name} />
                        }
                      </span>
                     
                    </div>
                    <div className="reedemcoupon-box-time">{moment(myReedemItem?.createdAt).format("DD/MM/YYYY, hh:mmA")}</div>
                  </div>

                  {/* Conditionally render reedemcoupon-box-details based on deliveryStatus */}
{myReedemItem?.deliveryStatus !== "FAILED" && (
  <div className="row reedemcoupon-box-details">
    <div className="col-11 reedemcoupon-box-code-section">
      {/* Check deliveryStatus and render code and pin accordingly */}
      {myReedemItem?.deliveryStatus === "pending" ? (
        <div className="reedemcoupon-box-message">
          {rewardDetails?.code || "-"}
        </div>
      ) : (
        myReedemItem?.deliveryStatus !== "pending" && (
          <div className="reedemcoupon-box-code">
            code: {rewardDetails?.code || "-"}
          </div>
        )
      )}
      {myReedemItem?.deliveryStatus === "delivered" && rewardDetails?.pin && (
        <div className="reedemcoupon-box-pin">
          pin: {rewardDetails?.pin || "-"}
        </div>
      )}
    </div>
    <div className="col-1 reedemcoupon-box-code-section flex">
      {/* Render the copy icon only if deliveryStatus is "delivered" */}
      {myReedemItem?.deliveryStatus === "delivered" && (
        <svg className="reedemebox-img" xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none" onClick={() => copyToClipboard(rewardDetails?.code || "")} >
          <g clipPath="url(#clip0_2916_5925)">
            <path d="M10.8735 2.40167L8.6185 0.122222C8.5415 0.0427778 8.4315 0 8.3215 0H3.806C2.948 0 2.255 0.702778 2.255 1.56444V2.27333H1.551C0.693 2.27333 0 2.97611 0 3.83778V10.6578C0 11.5194 0.6985 12.2222 1.551 12.2222H7.194C8.052 12.2222 8.745 11.5194 8.745 10.6578V9.94889H9.449C10.307 9.94889 11 9.24611 11 8.38444V2.70111C11 2.59111 10.956 2.48111 10.8735 2.40167ZM8.745 1.45444L9.559 2.27333H8.745V1.45444ZM7.898 10.6578C7.898 11.0489 7.5845 11.3667 7.194 11.3667H1.551C1.1605 11.3667 0.847 11.0489 0.847 10.6578V3.83778C0.847 3.44667 1.1605 3.12889 1.551 3.12889H2.255V8.38444C2.255 9.24611 2.9535 9.94889 3.806 9.94889H7.898V10.6578ZM9.449 9.09333H3.806C3.4155 9.09333 3.102 8.77556 3.102 8.38444V1.56444C3.102 1.17333 3.4155 0.855556 3.806 0.855556H7.898V2.70111C7.898 2.93944 8.085 3.12889 8.3215 3.12889H10.153V8.38444C10.153 8.77556 9.8395 9.09333 9.449 9.09333Z" fill="white" />
            <path d="M8.3215 6.82007H4.939C4.708 6.82007 4.5155 7.00951 4.5155 7.24785C4.5155 7.48618 4.7025 7.67562 4.939 7.67562H8.3215C8.5525 7.67562 8.745 7.48618 8.745 7.24785C8.745 7.00951 8.558 6.82007 8.3215 6.82007Z" fill="white" />
            <path d="M8.3215 4.54663H4.939C4.708 4.54663 4.5155 4.73608 4.5155 4.97441C4.5155 5.21274 4.7025 5.40219 4.939 5.40219H8.3215C8.5525 5.40219 8.745 5.21274 8.745 4.97441C8.745 4.73608 8.558 4.54663 8.3215 4.54663Z" fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_2916_5925">
              <rect width="11" height="12.2222" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </div>
  </div>
)}

                  <div className="reedemcoupon-box-divider--wrap">
                    <hr className="reedemcoupon-box-divider" />

                  </div>
                  <div className="reedemcoupon-title-steps">
                    steps to redeem
                  </div>
                  <div className="reedemcoupon-box-steps">
                    {rewardDetails?.stepsOfRedeem?.length > 0 ? rewardDetails?.stepsOfRedeem.map((steps, index) => (
                      <div className="reedemcoupon-box-step">
                        <span className="reedemcoupon-box-step-number">
                          • step {index + 1}
                        </span>
                        <span className="reedemcoupon-box-step-text">
                          {steps?.value}
                        </span>
                      </div>
                    )) : <></>}
                  </div>
                </div>

                {/* Right SVG */}
                <div className="reedemcoupon-box-right-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="38"
                    height="38"
                    viewBox="0 0 38 38"
                    fill="none"
                  >
                    <circle cx="19" cy="19" r="19" fill="#2D2E40" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReedemPopup;
